import React from "react";

const ChillerVanIndustries = ({ title, description, note, industries }) => {
  return (
    <section className="cv-industries-section">
      <div className="container">
        <div
          className="text-center"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-once="true"
        >
          <h2 className="mb-3">{title}</h2>
          <p className="text-light my-4">{description}</p>
        </div>

        <div className="row g-4 mt-2">
          {industries.map((industry, i) => (
            <div
              key={i}
              className="col-sm-6 col-lg-4"
              data-aos="fade-up"
              data-aos-delay={`${i * 100}`}
              data-aos-duration="700"
              data-aos-once="true"
            >
              <div className="cv-industry-card">
                <i className={`bi ${industry.icon} cv-industry-icon`}></i>
                <h3>{industry.title}</h3>
                <p>{industry.description}</p>
              </div>
            </div>
          ))}
        </div>

        {note && (
          <p
            className="text-center cv-industries-note"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-once="true"
          >
            {note}
          </p>
        )}
      </div>
    </section>
  );
};

export default ChillerVanIndustries;
